import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { IObservationInfo, RULE_LEVEL } from "@comunicare/comunicare-interfaces";
import * as moment from "moment";
import { ObservationsService } from "src/app/providers/observations.service";

@Component({
  selector: "app-observation-single-period",
  templateUrl: "./observation-single-period.component.html",
  styleUrls: ["./observation-single-period.component.scss"],
})
export class ObservationSinglePeriodComponent implements OnInit {
  @Input() date: string;
  @Input() observations: IObservationInfo[];

  public RULE_LEVEL = RULE_LEVEL;
  public isToday = false;

  constructor(private dialog: MatDialog, private observationService: ObservationsService) {}
  ngOnInit(): void {
    this.isToday = moment(this.date).isSame(moment(), "day");
  }
}
